// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609211304/js/" + chunkId + "." + {"44":"da18b286","225":"6e2339cd","481":"1354c52d","486":"6bebedea","770":"3ca43e17"}[chunkId] + ".0.4365741578074279.chunk.js";
};